import { render, staticRenderFns } from "./NoteRender.vue?vue&type=template&id=572828ba&functional=true"
import script from "./NoteRender.vue?vue&type=script&lang=js"
export * from "./NoteRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports